<template>
  <div class="container-fluid">
    <div class="row tick-row">
      <main id="main" class="site-main main-content">
        <div class="contact-banner"></div>

        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-5">
                    <h2 class="wow fadeIn">Send Message</h2>
                    <p class="wow fadeIn">
                      Please fill out our form, and we’ll get in touch shortly.
                    </p>
                    <br />
                    <div role="form" class="wpcf7" dir="ltr" lang="en-US">
                      <div class="screen-reader-response"></div>
                      <form
                        @submit.prevent="submitForm"
                        id="contactUsForm"
                        action="#"
                        method="post"
                        class="wpcf7-form"
                        novalidate="novalidate"
                      >
                        <div class="hostcluster-contact-none">
                          <input name="_wpcf7" value="2260" type="hidden" />
                          <input
                            name="_wpcf7_version"
                            value="5.0.3"
                            type="hidden"
                          />
                          <input
                            name="_wpcf7_locale"
                            value="en_US"
                            type="hidden"
                          />
                          <input
                            name="_wpcf7_unit_tag"
                            value="wpcf7-f2260-p2252-o1"
                            type="hidden"
                          />
                          <input
                            name="_wpcf7_container_post"
                            value="2252"
                            type="hidden"
                          />
                        </div>
                        <div class="hostcluster-contact row">
                          <div class="col-md-6">
                            <label
                              >First Name<span
                                class="wpcf7-form-control-wrap first-name"
                                ><input
                                  v-model="contactUsFormFirstName"
                                  name="firstName"
                                  size="40"
                                  class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                  :class="{
                                    hasError:
                                      contactUsFormError ||
                                      contactUsFormFirstNameError,
                                  }"
                                  aria-required="true"
                                  aria-invalid="false"
                                  placeholder="Insert your first name"
                                  type="text" /></span
                            ></label>
                            <p
                              class="form-error"
                              v-if="contactUsFormFirstNameError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                margin: -15px 0px 15px;
                              "
                            >
                              First name is required.
                            </p>
                          </div>
                          <div class="col-md-6">
                            <label
                              >Last Name<span
                                class="wpcf7-form-control-wrap last-name"
                                ><input
                                  v-model="contactUsFormLastName"
                                  name="lastName"
                                  required
                                  size="40"
                                  class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                  :class="{
                                    hasError:
                                      contactUsFormError ||
                                      contactUsFormLastNameError,
                                  }"
                                  aria-required="true"
                                  aria-invalid="false"
                                  placeholder="Insert your last name"
                                  type="text" /></span
                            ></label>
                            <p
                              class="form-error"
                              v-if="contactUsFormLastNameError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                margin: -15px 0px 15px;
                              "
                            >
                              Last name is required.
                            </p>
                          </div>
                          <div class="col-md-12">
                            <label
                              >Your E-mail<span
                                class="wpcf7-form-control-wrap email"
                                ><input
                                  v-model="contactUsFormEmail"
                                  name="email"
                                  size="40"
                                  class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                  :class="{
                                    hasError:
                                      contactUsFormEmailFormatError ||
                                      contactUsFormEmailError ||
                                      contactUsFormError,
                                  }"
                                  aria-required="true"
                                  aria-invalid="false"
                                  placeholder="Insert your email"
                                  required
                                  type="email" /></span
                            ></label>
                            <p
                              class="form-error"
                              v-if="contactUsFormEmailError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                margin: -15px 0px 15px;
                              "
                            >
                              Email required.
                            </p>
                            <p
                              class="form-error"
                              v-if="contactUsFormEmailFormatError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                margin: -15px 0px 15px;
                              "
                            >
                              Invalid email format. Please enter valid email
                              address.
                            </p>
                          </div>
                          <div class="col-md-12">
                            <label
                              >Choose your service<span
                                class="wpcf7-form-control-wrap select-options"
                                ><select
                                  v-model="contactUsFormService"
                                  name="selectOptions"
                                  class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                                  :class="{ hasError: contactUsFormError }"
                                  aria-required="true"
                                  aria-invalid="false"
                                  required
                                  style="background: white"
                                >
                                  <option value="General">General</option>
                                  <option value="Personal">Personal</option>
                                  <option value="Business">Business</option>
                                  <option value="Legal">Legal</option>
                                  <option value="Billing">Billing</option>
                                </select></span
                              ></label
                            >
                            <p
                              class="form-error"
                              v-if="contactUsFormServiceError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                margin: -35px 0px 15px;
                              "
                            >
                              Service required.
                            </p>
                          </div>
                          <div class="col-md-12">
                            <label
                              >Your Message<span
                                class="wpcf7-form-control-wrap your-message"
                              >
                                <textarea
                                  v-model="contactUsFormMessage"
                                  name="message"
                                  required
                                  cols="3"
                                  rows="3"
                                  class="wpcf7-form-control wpcf7-textarea"
                                  :class="{ hasError: contactUsFormError }"
                                  aria-invalid="false"
                                  placeholder="Enter your message"
                                  style="background: white"
                                ></textarea></span
                            ></label>
                            <p
                              class="form-error"
                              v-if="contactUsFormMessageError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                margin: -35px 0px 15px;
                              "
                            >
                              Message required.
                            </p>
                          </div>
                          <div class="col-md-12 text-center" v-if="recaptchaToken === null" style="margin-bottom: 50px">
                              <vue-recaptcha
                                ref="recaptcha"
                                @verify="onCaptchaVerified"
                                @expired="onCaptchaExpired"
                                sitekey="6LektFYaAAAAAFLNPWH6-haAoVbtIeZ5xuBE5sJc"
                              ></vue-recaptcha>
                          </div>
                          <div class="col-md-12 text-center">
                            <p
                              class="form-error"
                              v-if="contactUsFormSuccess"
                              style="color: green; font-size: 1em; font-weight: bold;background: #aee0ae;padding: 10px; border-radius: 5px;}"
                            >
                              Message Sent.
                            </p>
                            <p
                              class="form-error"
                              v-if="contactUsFormError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                background: #ffb6b6;
                                padding: 10px;
                                border-radius: 5px;
                              "
                            >
                              Please fill form.
                            </p>
                            <p
                              class="form-error"
                              v-if="submitError"
                              style="
                                color: red;
                                font-size: 1em;
                                font-weight: bold;
                                background: #ffb6b6;
                                padding: 10px;
                                border-radius: 5px;
                              "
                            >
                              Something went wrong. Please try again.
                            </p>
                          </div>
                          <div class="col-md-12 text-center">
                            <input
                                v-if="recaptchaToken !== null"
                                value="SEND MESSAGE"
                                class="wpcf7-form-control wpcf7-submit"
                                type="submit"
                                style="margin-bottom: 80px;"
                              />
                            <span class="ajax-loader"></span>
                          </div>
                        </div>
                        <div
                          class="wpcf7-response-output wpcf7-display-none"
                        ></div>
                      </form>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-7">
                    <h2 class="wow fadeIn">Our Address</h2>
                    <div class="wow fadeIn">
                      <p>
                        <span
                          >Personal information such as password, account/credit card numbers, NIC/passport numbers or any personal identification information will not be requested by us via our inquiry forms. Hence please refrain from sharing any such information.</span
                        >
                      </p>
                    </div>
                    <div class="spacer_10"></div>
                    <div class="wow fadeIn">
                      <p>
                        <span
                          >Please visit our frequently asked questions if you have any query about the services of Clear Me Out. If your question is not answered, please use the ‘Message Form’ or the ‘List’ given below to contact us.</span
                        >
                      </p>
                    </div>
                    <div class="spacer_15"></div>
                    <div
                      class="mt_services-shortcode row text-center skin_dark"
                    >
                      <div
                        class="mt_icon_services_item style_v1 col-sm-6 col-md-4 mt_icon_services_item_5b487ee758d5b"
                      >
                        <div class="hc_icon_element">
                          <span class="icon icon-pin"></span>
                        </div>
                        <h3 class="menu_item_title">Address</h3>
                        <p class="menu_item_content">
                          Clear Me Out (Pvt) Ltd., Level 50, 120 Collins St, Melbourne VIC 3000, Australia.
                        </p>
                      </div>
                      <div
                        class="mt_icon_services_item style_v1 col-sm-6 col-md-4 mt_icon_services_item_5b487ee758fde"
                      >
                        <div class="hc_icon_element">
                          <span class="icon icon-phone"></span>
                        </div>
                        <h3 class="menu_item_title">Phone</h3>
                        <p class="menu_item_content">
                          + 61 (39) 0216735 <br />
                          + 61 (39) 0216766
                        </p>
                      </div>
                      <div
                        class="mt_icon_services_item style_v1 col-sm-6 col-md-4 mt_icon_services_item_5b487ee75908f"
                      >
                        <div class="hc_icon_element">
                          <span class="icon icon-envelope"></span>
                        </div>
                        <h3 class="menu_item_title">E-mail</h3>
                        <p class="menu_item_content">
                          service@clearmeout.com <br />
                          support@clearmeout.com <br />
                          legal@clearmeout.com
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="hc-map">
              <div class="row">
                <div class="col-sm-12">
                  <div class="wow adeInUp">
                    <div class="wpb_map_wraper">
                      <iframe
                        class="contact-map"
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d787.9899679414217!2d144.9695832!3d-37.8144089!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQ4JzUxLjQiUyAxNDTCsDU4JzExLjMiRQ!5e0!3m2!1sen!2slk!4v1614340173638!5m2!1sen!2slk"
                        width="600"
                        height="450"
                        frameborder="0"
                        style="border: 0"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: "contact_us",
  methods: {
    onCaptchaVerified: function(recaptchaToken) {
      const $this = this;

      $this.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired: function () {
      const $this = this;
      $this.$refs.recaptcha.reset();
      $this.recaptchaToken = null;
    },
    submitForm: function () {
      const $this = this;

      this.contactUsFormError = false;
      this.contactUsFormFirstNameError = false;
      this.contactUsFormLastNameError = false;
      this.contactUsFormEmailError = false;
      this.contactUsFormServiceError = false;
      this.contactUsFormMessageError = false;
      this.submitError = false;
      this.contactUsFormEmailFormatError = false;
      this.contactUsFormSuccess = false;

      if (
        this.contactUsFormFirstName === "" &&
        this.contactUsFormLastName === "" &&
        this.contactUsFormEmail === "" &&
        this.contactUsFormService === "" &&
        this.contactUsFormMessage === ""
      ) {
        $this.contactUsFormError = true;
        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }

      $this.contactUsFormError = false;

      if (this.contactUsFormFirstName === "") {
        $this.contactUsFormFirstNameError = true;
        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      if (this.contactUsFormLastName === "") {
        $this.contactUsFormLastNameError = true;
        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      if (this.contactUsFormEmail === "") {
        $this.contactUsFormEmailError = true;
        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }

      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(String(this.contactUsFormEmail).toLowerCase())) {
        $this.contactUsFormEmailFormatError = true;
        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }

      if (this.contactUsFormService === "") {
        $this.contactUsFormServiceError = true;
        
        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      if (this.contactUsFormMessage === "") {
        $this.contactUsFormMessageError = true;
        
        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }

      $this.contactUsFormError = false;
      $this.contactUsFormEmailError = false;

      emailjs
        .sendForm("service_cq4h4ph", "template_3do3yng", "#contactUsForm")
        .then(
          function (response) {
            console.log("SUCCESS!", response.status, response.text);
            $this.contactUsFormSuccess = true;

            $this.recaptchaToken = null;

            setTimeout(() => {
              $this.$refs.recaptcha.reset()
            }, 100);
          },
          function (error) {
            console.log("FAILED...", error);
            $this.submitError = true;
            $this.recaptchaToken = null;

            setTimeout(() => {
              $this.$refs.recaptcha.reset()
            }, 100);
          }
        );
    },
  },
  data() {
    return {
      msg: "Clear Me Out - Contact Us",
      recaptchaToken: null,
      contactUsFormError: false,
      contactUsFormEmailError: false,
      contactUsFormFirstNameError: false,
      contactUsFormLastNameError: false,
      contactUsFormSuccess: false,
      contactUsFormServiceError: false,
      contactUsFormMessageError: false,
      contactUsFormEmailFormatError: false,
      submitError: false,
      contactUsFormFirstName: "",
      contactUsFormLastName: "",
      contactUsFormEmail: "",
      contactUsFormService: "",
      contactUsFormMessage: "",
    };
  },
  components: {
    'vue-recaptcha': VueRecaptcha
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.hasError {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue